import { render, staticRenderFns } from "./TableFilterHeader.vue?vue&type=template&id=3ed22670&scoped=true"
import script from "./TableFilterHeader.vue?vue&type=script&lang=js"
export * from "./TableFilterHeader.vue?vue&type=script&lang=js"
import style0 from "./TableFilterHeader.vue?vue&type=style&index=0&id=3ed22670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed22670",
  null
  
)

export default component.exports